var React = require('react');
var router = require('react-router');
var Link = router.Link;

var ABOUT = require('../about-copy');

var DEFAULT_TITLE = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';

var About = React.createClass({
  componentDidMount: function() {
    document.title = ABOUT.title;
  },
  componentWillUnmount: function() {
    document.title = DEFAULT_TITLE;
  },
  render: function() {
    var sections = ABOUT.sections.map(function(section) {
      return (
        <section className="guide-section" key={section.h}>
          <h2>{section.h}</h2>
          {section.p.map(function(text) {
            return <p key={text}>{text}</p>;
          })}
        </section>
      );
    });
    return (
      <article className="content-page guide-page">
        <div className="detail-toolbar">
          <Link to="/" className="back-link">← Back to search</Link>
        </div>
        <h1 className="content-h1">{ABOUT.h1}</h1>
        <p className="content-lead">{ABOUT.lead}</p>
        {sections}
        <p className="content-cta">
          <Link to="/guides/poker-tournament-faq">poker tournament FAQ</Link>
          {' · '}
          <Link to="/texas-poker-rooms">Texas poker rooms</Link>
          {' · '}
          <Link to="/">search schedules</Link>
        </p>
      </article>
    );
  }
});

module.exports = About;



// WEBPACK FOOTER //
// ./js/pages/about.jsx